(function () {
  function debounce(fn, wait) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function parseConfig(section) {
    return {
      dynamic: section.dataset.saDynamic === 'true',
      maxDesktop: parseInt(section.dataset.saMaxDesktop, 10) || 5,
      loop: section.dataset.saLoop === 'true',
      autoplay: section.dataset.saAutoplay === 'true',
      autoplayDelay: (parseInt(section.dataset.saAutoplayDelay, 10) || 4) * 1000,
      effect: section.dataset.saEffect || 'slide',
      direction: section.dataset.saDirection || 'horizontal',
      shortSwipes: section.dataset.saShortSwipes !== 'false',
    };
  }

  function getLimits(config) {
    return {
      maxViews: config.maxDesktop,
      spaceBetween: 0,
    };
  }

  /** Natural width unaffected by Swiper slide sizing */
  function measureNaturalColWidths(section) {
    var cols = section.querySelectorAll('.slider-attributes__slide .slider-attributes__col');
    if (!cols.length) {
      cols = section.querySelectorAll('.slider-attributes__col');
    }

    var widths = [];

    cols.forEach(function (col) {
      if (col.closest('.swiper-slide-duplicate')) return;

      var clone = col.cloneNode(true);
      clone.style.cssText =
        'position:absolute;left:-9999px;top:0;visibility:hidden;width:max-content;height:auto;pointer-events:none;';
      document.body.appendChild(clone);
      widths.push(clone.getBoundingClientRect().width);
      document.body.removeChild(clone);
    });

    return widths;
  }

  function getWidestNaturalWidth(swiperEl) {
    var widths = swiperEl._saNaturalWidths;
    if (!widths || !widths.length) return 0;
    return Math.max.apply(null, widths);
  }

  function calcFittingSlidesPerView(swiper, config) {
    var limits = getLimits(config);
    var containerWidth = swiper.width || swiper.el.clientWidth;
    var widest = getWidestNaturalWidth(swiper.el);
    var space = limits.spaceBetween;
    var views = limits.maxViews;

    if (!containerWidth || !widest) {
      return Math.max(1, views);
    }

    while (views > 1) {
      var slotWidth = (containerWidth - space * (views - 1)) / views;
      if (slotWidth >= widest - 1) break;
      views -= 1;
    }

    return Math.max(1, views);
  }

  function applyDynamicSlidesPerView(swiper, config) {
    var limits = getLimits(config);
    var views = config.dynamic
      ? calcFittingSlidesPerView(swiper, config)
      : limits.maxViews;
    var currentViews = Number(swiper.params.slidesPerView);

    if (currentViews === views && swiper.params.spaceBetween === limits.spaceBetween) {
      return;
    }

    swiper.params.slidesPerView = views;
    swiper.params.spaceBetween = limits.spaceBetween;
    swiper.update();
  }

  function bindResizeHandlers(section, swiper, config) {
    if (!config.dynamic) return;

    if (section._saOnResize) {
      window.removeEventListener('resize', section._saOnResize);
    }
    if (section._saResizeObserver) {
      section._saResizeObserver.disconnect();
    }

    var refresh = function () {
      applyDynamicSlidesPerView(swiper, config);
    };

    section._saOnResize = debounce(refresh, 80);
    window.addEventListener('resize', section._saOnResize);

    if (typeof ResizeObserver !== 'undefined') {
      section._saResizeObserver = new ResizeObserver(debounce(refresh, 80));
      section._saResizeObserver.observe(swiper.el);
      var inner = section.querySelector('.slider-attributes__inner');
      if (inner) section._saResizeObserver.observe(inner);
    }
  }

  function cleanupSection(section) {
    if (section._saOnResize) {
      window.removeEventListener('resize', section._saOnResize);
      section._saOnResize = null;
    }
    if (section._saResizeObserver) {
      section._saResizeObserver.disconnect();
      section._saResizeObserver = null;
    }
  }

  function buildSwiperOptions(swiperEl, config) {
    var limits = getLimits(config);
    return {
      autoHeight: false,
      loop: config.loop,
      effect: config.effect,
      direction: config.direction,
      slidesPerView: limits.maxViews,
      spaceBetween: limits.spaceBetween,
      preventClicks: false,
      preventClicksPropagation: false,
      shortSwipes: config.shortSwipes,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      on: {
        init: function (swiper) {
          if (config.dynamic) applyDynamicSlidesPerView(swiper, config);
        },
        resize: function (swiper) {
          if (config.dynamic) applyDynamicSlidesPerView(swiper, config);
        },
      },
      autoplay: config.autoplay
        ? {
            delay: config.autoplayDelay,
            disableOnInteraction: true,
          }
        : undefined,
    };
  }

  function initSection(section) {
    if (!section || typeof Swiper === 'undefined') return;

    var swiperEl = section.querySelector('.slider-attributes__swiper');
    if (!swiperEl) return;

    cleanupSection(section);

    if (swiperEl.sliderAttributesSwiper) {
      swiperEl.sliderAttributesSwiper.destroy(true, true);
      swiperEl.sliderAttributesSwiper = null;
    }

    var config = parseConfig(section);
    swiperEl._saNaturalWidths = measureNaturalColWidths(section);

    var swiper = new Swiper(swiperEl, buildSwiperOptions(swiperEl, config));
    swiperEl.sliderAttributesSwiper = swiper;

    if (config.dynamic) {
      applyDynamicSlidesPerView(swiper, config);
      bindResizeHandlers(section, swiper, config);

      var remeasure = function () {
        swiperEl._saNaturalWidths = measureNaturalColWidths(section);
        applyDynamicSlidesPerView(swiper, config);
      };

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(remeasure);
      }
    }
  }

  function initAll() {
    document
      .querySelectorAll('[data-section-type="slider-attributes"]')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-section-type="slider-attributes"]');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-section-type="slider-attributes"]');
    var swiperEl = event.target.querySelector('.slider-attributes__swiper');

    if (section) cleanupSection(section);

    if (swiperEl && swiperEl.sliderAttributesSwiper) {
      swiperEl.sliderAttributesSwiper.destroy(true, true);
      swiperEl.sliderAttributesSwiper = null;
    }
  });
})();
